import React from 'react';
import { Bar } from 'react-chartjs-2';

const BarChart = props => {
  const { name, labels, values } = props;
  const data = {
    labels,
    datasets: [
      {
        label: name,
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(255,99,132,0.4)',
        hoverBorderColor: 'rgba(255,99,132,1)',
        data: values
      }
    ]
  };
  return (
    <div>
      <h3>{name}</h3>
      <Bar
        data={data}
        width={100}
        height={15}
        options={{
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  min: 0,
                  stepSize: 10
                }
              }
            ]
          }
        }}
      />
    </div>
  );
};

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/Admin/surveys/Results/ResultsWithCharts/charts/bar.js